/** Declaration boundaries shared by the lightweight HTML parser and inline PDF styles. */
export class kCssDeclarationCore {
    /** DOCUMENTED EXCEPTION: pure text splitting; callers own gates and malformed-input reporting.
     * Preserve declaration text and empty fragments; semicolons inside quotes or parentheses
     * belong to the value. An unfinished quote or parenthesis keeps the remaining text intact.
     */
    public static Split = (Style: string): string[] => {
        const Parts: string[] = [];
        let Start: number = 0;
        let Depth: number = 0;
        let Quote: string = "";
        let Escaped: boolean = false;
        for (let Index: number = 0; Index < Style.length; Index++) {
            const Character: string = Style.charAt(Index);
            if (Escaped) { Escaped = false; continue; }
            if (Character === "\\") { Escaped = true; continue; }
            if (Quote !== "") {
                if (Character === Quote) { Quote = ""; }
                continue;
            }
            if (Character === "'" || Character === '"') { Quote = Character; continue; }
            if (Character === "(") { Depth++; continue; }
            if (Character === ")" && Depth > 0) { Depth--; continue; }
            if (Character === ";" && Depth === 0) {
                Parts.push(Style.substring(Start, Index));
                Start = Index + 1;
            }
        }
        Parts.push(Style.substring(Start));
        return Parts;
    };
}
